<div class="form-field">
  @if(label) {
  <label class="form-field__label">
    {{ label }}
    @if(required) {
    <span class="form-field__required">*</span>
    }
  </label>
  }
  <div class="form-field__number-wrapper">
    <!-- Country Dropdown -->
    <div
      class="form-field__country-code-wrapper form-field__country-code-wrapper--{{ size }}"
      [ngClass]="{
        'form-field__country-code-wrapper--invalid': isInvalid,
        'form-field__country-code-wrapper--disabled': disabled || control?.disabled
      }"
    >
      <select
        class="form-field__country-code"
        [value]="countryCode"
        (change)="onCountryChange($event)"
        [disabled]="disabled"
        tabindex="-1"
      >
        @for(c of countries; track $index) {
        <option [value]="c.dialCode" [selected]="c.dialCode === countryCode">
          <!-- {{ c.flag }} -->
          {{ c.code }} ({{ c.dialCode }})
        </option>
        }
      </select>
    </div>
    <!-- Mobile Number Input -->
    <input
      type="tel"
      [id]="formControlName"
      [placeholder]="placeholder"
      [disabled]="disabled || control?.disabled"
      [value]="value"
      (input)="onInput($event)"
      (keypress)="allowOnlyNumbers($event)"
      (paste)="allowOnlyPasteNumbers($event)"
      (blur)="onTouched()"
      class="form-field__number form-field__number--{{ size }}"
      [ngClass]="{
        'form-field__number--invalid': isInvalid,
        'form-field__number--disabled': disabled || control?.disabled
      }"
    />
  </div>

  @if(errorMessage) {
  <div class="form-field__error">{{ errorMessage }}</div>
  }
</div>
